import { render, staticRenderFns } from "./qrMusic.vue?vue&type=template&id=31377d30"
import script from "./qrMusic.vue?vue&type=script&lang=js"
export * from "./qrMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports